import {SettingsIcon} from '@100mslive/react-icons';
import {
  selectAvailableRoleNames,selectPeerByID,
  useHMSActions,useHMSStore
} from '@100mslive/react-sdk';
import {Button,Dialog,styled} from '@100mslive/roomkit-react';
import React,{useState} from 'react';
import {decryptText} from '../utils/CommonFunction';
import {
  DialogCheckbox,
  DialogContent,
  DialogRow,
  DialogSelect
} from './primitives/DialogContent';

export const RoleChangeModal = ({peerId, onOpenChange}: any) => {
  const peer = useHMSStore(selectPeerByID(peerId));
  const roles = useHMSStore(selectAvailableRoleNames);
  const [selectedRole, setRole] = useState(peer?.roleName || '');
  const [requestPermission, setRequestPermission] = useState(true);
  const hmsActions = useHMSActions();
  if (!peer) {
    return null;
  }
  return (
    <Dialog.Root defaultOpen onOpenChange={onOpenChange}>
      <DialogContent
        Icon={SettingsIcon}
        title={`User Settings (${ decryptText(peer?.name) || 'peer left'})`}
        css={{
          width: '80%'
        }}
      >
        <DialogSelect
          title="Change role to"
          options={roles}
          selected={selectedRole}
          onChange={setRole}
        />
        {!peer?.isLocal && (
          <DialogCheckbox
            title="Request Permission"
            value={requestPermission}
            onChange={setRequestPermission}
            id="requestRoleChangePermission"
          />
        )}
        <DialogRow justify="end">
          <Button
            variant="primary"
            onClick={async () => {
              await hmsActions.changeRole(
                peerId,
                selectedRole,
                peer.isLocal ? true : !requestPermission
              );
              onOpenChange(false);
            }}
          >
            Confirm
          </Button>
        </DialogRow>
      </DialogContent>
    </Dialog.Root>
  );
};